// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store';
import axios from 'axios'
import VueAxios from 'vue-axios'
import clipboard from 'clipboard';
import echarts from 'echarts'
import Victor from './assets/vector.js'
Vue.config.productionTip = false
Vue.use(VueAxios,axios);
Vue.use(ElementUI);
//定义全局变量
import http from './utils/http'
Vue.prototype.$axios = http;
Vue.prototype.clipboard = clipboard;
Vue.prototype.$echarts = echarts;

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js